import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './EliteServersSection.module.scss'
import SnakeLeaderboard from './SnakeLeaderboard/SnakeLeaderboard'

const EliteServersSection = () => {
  const navigate = useNavigate()
  const [betaOpen, setBetaOpen] = useState(false)

  return (
    <section className={styles.section}>
      <div className={styles.container}>

        {/* Elite Servers Blocks */}
        <div className={styles.eliteServersWrapper}>
          <a href="https://cs2.ncore.kg" target="_blank" rel="noopener noreferrer"
            className={styles.eliteServerBlock}
            style={{ '--accent-color': '#F59E0B', '--glow-color': '#F59E0B' }}
          >
            <div className={styles.eliteServerInfo}>
              <span className={styles.eliteServerLabel}>Official Server in NCORE</span>
              <h3 className={styles.eliteServerTitle}>Counter-Strike 2</h3>
              <div className={styles.eliteServerAddress}>cs2.ncore.kg</div>
              <div className={styles.joinButton}>
                Присоединиться <span style={{ fontSize: '18px', marginLeft: '4px' }}>→</span>
              </div>
            </div>
            <div className={styles.eliteServerIconWrapper}>
              <svg className={styles.eliteServerIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z" />
                <line x1="12" y1="2" x2="12" y2="4" />
                <line x1="12" y1="20" x2="12" y2="22" />
                <line x1="2" y1="12" x2="4" y2="12" />
                <line x1="20" y1="12" x2="22" y2="12" />
              </svg>
            </div>
          </a>

          <a href="https://mc.ncore.kg" target="_blank" rel="noopener noreferrer"
            className={styles.eliteServerBlock}
            style={{ '--accent-color': '#10B981', '--glow-color': '#10B981' }}
          >
            <div className={styles.eliteServerInfo}>
              <span className={styles.eliteServerLabel}>Official Server in NCORE</span>
              <h3 className={styles.eliteServerTitle}>Minecraft</h3>
              <div className={styles.eliteServerAddress}>mc.ncore.kg</div>
              <div className={styles.joinButton}>
                Присоединиться <span style={{ fontSize: '18px', marginLeft: '4px' }}>→</span>
              </div>
            </div>
            <div className={styles.eliteServerIconWrapper}>
              <svg className={styles.eliteServerIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                <line x1="12" y1="22.08" x2="12" y2="12" />
              </svg>
            </div>
          </a>

          <div
            className={styles.eliteServerBlock}
            style={{ '--accent-color': '#6366F1', '--glow-color': '#6366F1', cursor: 'pointer' }}
            onClick={() => navigate('/chats')}
          >
            <div className={styles.eliteServerInfo}>
              <span className={styles.eliteServerLabel}>Живое общение в NCORE</span>
              <h3 className={styles.eliteServerTitle}>Чаты & Войс</h3>
              <div className={styles.eliteServerAddress}>Найди своих людей</div>
              <div className={styles.joinButton}>
                Начать общение <span style={{ fontSize: '18px', marginLeft: '4px' }}>→</span>
              </div>
            </div>
            <div className={styles.eliteServerIconWrapper}>
              <svg className={styles.eliteServerIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                <circle cx="9" cy="10" r="1" fill="currentColor" stroke="none" />
                <circle cx="13" cy="10" r="1" fill="currentColor" stroke="none" />
                <circle cx="17" cy="10" r="1" fill="currentColor" stroke="none" />
              </svg>
            </div>
          </div>

          <div
            className={styles.eliteServerBlock}
            style={{ '--accent-color': '#a855f7', '--glow-color': '#ec4899', cursor: 'pointer' }}
            onClick={() => navigate('/services/shop')}
          >
            <div className={styles.eliteServerInfo}>
              <span className={styles.eliteServerLabel}>NCORE Marketplace</span>
              <h3 className={styles.eliteServerTitle}>Магазин</h3>
              <div className={styles.eliteServerAddress}>Товары от продавцов</div>
              <div className={styles.joinButton}>
                Открыть каталог <span style={{ fontSize: '18px', marginLeft: '4px' }}>→</span>
              </div>
            </div>
            <div className={styles.eliteServerIconWrapper}>
              <svg className={styles.eliteServerIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <path d="M16 10a4 4 0 0 1-8 0"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Beta Announcement Banner */}
        <div className={`${styles.betaBanner} ${betaOpen ? styles.betaBannerOpen : ''}`}>
          <button className={styles.betaBar} onClick={() => setBetaOpen(o => !o)}>
            <div className={styles.betaBarLeft}>
              <span className={styles.betaDot} />
              <span className={styles.betaBarBadge}>БЕТА</span>
              <span className={styles.betaBarTitle}>  Мы только начинаем — нажмите, чтобы узнать больше</span>
            </div>
            <span className={`${styles.betaChevron} ${betaOpen ? styles.betaChevronOpen : ''}`}>›</span>
          </button>
          <div className={styles.betaBody}>
            <p className={styles.betaText}>
              NCORE находится в активной фазе бета-запуска.<br /> Если что-то кажется недоработанным или дизайн не тот, — это нормально.
              Мы слушаем вас и работаем, чтобы платформа становилась по-настоящему удобной именно для вас.<br />
              Готовим новый контент: аниме и видео даже с плохим интернетом, игры, общение и многое другое — всё в одном месте.
            </p>
            <button className={styles.betaFeedbackBtn} onClick={() => navigate('/feedback')}>
              Оставить предложение →
            </button>
          </div>
        </div>

        <SnakeLeaderboard />

      </div>
    </section>
  )
}

export default EliteServersSection
